module.exports = __webpack_public_path__ + "img/background_12.1a81e9fb.jpg";